import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './EnvironmentBanner.css';

/**
 * Environment banner displayed at the top of the page for non-production environments.
 * Helps users quickly identify which environment they are working in.
 */
const ENV_CONFIG = {
  pre: {
    label: 'PRE-PRODUCTION',
    icon: 'bi bi-exclamation-triangle-fill',
  },
  test: {
    label: 'TEST ENVIRONMENT',
    icon: 'bi bi-flask',
  },
  localhost: {
    label: 'LOCAL DEVELOPMENT',
    icon: 'bi bi-code-slash',
  },
};

const EnvironmentBanner = memo(({ environment }) => {
  if (!environment || environment === 'prod') return null;

  const config = ENV_CONFIG[environment];
  if (!config) return null;

  return (
    <div className={`env-banner env-banner--${environment}`} role="status" aria-label={`${config.label} environment`}>
      <i className={config.icon} aria-hidden="true" />
      <span>You are working in {config.label}</span>
      <i className={config.icon} aria-hidden="true" />
    </div>
  );
});

EnvironmentBanner.displayName = 'EnvironmentBanner';

EnvironmentBanner.propTypes = {
  environment: PropTypes.string,
};

export default EnvironmentBanner;
